// extracted by mini-css-extract-plugin
module.exports = {"section-title":"personal-plan-home-page_section-title__l5fJO","modals-layer":"personal-plan-home-page_modals-layer__MOANS"};